import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config/config";

export default function ButcherPayments() {
  const [payments, setPayments] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseUrl}/api/butcher/payment_details`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setPayments(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to fetch Butcher Payments", error);
      setPayments([]);
    }
  };

  const handlePrint = async (doc_no, item) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${config.baseUrl}/api/butcher/printSlip/${doc_no}?date=${encodeURIComponent(item.last_entry)}`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      const data = await response.json();

      if (data) {
        // Data ko local storage mein save karein
        localStorage.setItem('temp_butcher_slip', JSON.stringify(data));
        // Naye tab mein print page kholein
        window.open('/butcher/slip', '_blank');
      }
    } catch (error) {
      alert("Slip load karne mein masla hua.");
    }
  };

  const grandTotal = payments.reduce((sum, item) => sum + Number(item.total_amount || 0), 0);

  return (
    <main className="min-h-screen bg-slate-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-end mb-8">
          <h1 className="text-3xl font-extrabold text-slate-900 uppercase">Butcher Payments</h1>
          <button
            onClick={() => navigate("/butcher/new-payment")}
            className="bg-blue-600 text-white px-6 py-3 rounded-xl font-bold uppercase text-xs"
          >
            + Record Payment
          </button>
        </div>

        <div className="bg-white rounded-[2rem] shadow-lg overflow-hidden border border-slate-200">
          <div className="bg-slate-900 px-8 py-5 flex justify-between items-center text-white">
            <span className="font-bold text-xs tracking-widest uppercase">Transaction Ledger</span>
            <span className="font-black">PKR {grandTotal.toLocaleString()}</span>
          </div>
          <table className="w-full text-left">
            <thead className="bg-slate-50 text-[10px] uppercase text-slate-400 font-bold">
              <tr className="text-center">
                <th className="px-6 py-4">S.No</th>
                <th className="px-6 py-4">Doc No.</th>
                <th className="px-6 py-4">Butcher Name</th>
                <th className="px-6 py-4">Contact</th>
                <th className="px-6 py-4">Amount</th>
                <th className="px-6 py-4">Date</th>
                <th className="px-6 py-4">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {payments.map((item, index) => (
                <tr key={index} className="hover:bg-slate-50 text-center">
                  <td className="px-6 py-4 text-slate-400">{index + 1}</td>
                  <td className="px-6 py-4 font-bold text-slate-800 uppercase">{item.doc_no}</td>
                  <td className="px-6 py-4 font-bold text-slate-800 uppercase">{item.name}</td>
                  <td className="px-6 py-4 font-bold text-slate-800 uppercase">{item.contact}</td>
                  <td className="px-6 py-4 text-right font-bold text-blue-600">PKR {Number(item.total_amount).toLocaleString()}</td>
                  <td className="px-6 py-4 text-center text-slate-500">{item.last_entry}</td>
                  <td className="px-6 py-4 text-center">
                    <button onClick={() => handlePrint(item.doc_no, item)} className="p-2 bg-slate-100 rounded-lg hover:bg-blue-600 hover:text-white transition-all">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                      </svg>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </main>
  );
}